import airbnb from './images/airbnb.jpg'
import gym from './images/gym.jpg';
import website from './images/website.jpg'

const PData= [
    {
        id:1,
        title:"Web Projects",
        link:"",
        para:"lorem  sidhghphjp sjpoepthpojspthjop jp ojpthjoj pijw",
        img:website,
    },
    {
        id:2,
        title:"Gym Website",
        link:"https://humfitness.netlify.app/",
        para:"lorem  sidhghphjp sjpoepthpojspthjop jp ojpthjoj pijw",
        img:gym,
    },
    {
        id:3,
        title:"AirBnb Static",
        link:"https://csb-55nu0.netlify.app/",
        para:"lorem  sidhghphjp sjpoepthpojspthjop jp ojpthjoj pijw",
        img:airbnb,
    },

]
export default PData;